export function isWXBrowser(): boolean {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.match(/micromessenger/i)) {
    return true // 是微信端
  }
  return false
}
